<i18n src="../../../locales/lang.json"></i18n>

<template>
  <div class="card shadow-0 text-center" v-bind:id="getId()" style="float:left; width:200px; margin-left:15px;">

     <div class="card-header bg-dark header-elements-inline px-0 pb-1" style="border:none;">
    <div class="row" style="width:100%;">
      <div class="col-10 pl-3 text-left pt-1" style="font-size:10px;">
        
        {{$t('time_done')}}
      </div>
      <div class="col-2 pt-1" style="text-align:right;line-height:10px;padding-right:0px">
        <a class="list-icons-item" @click="removeMe" data-action="remove" style="margin-top:-4px;"></a>
      </div>
      <div class="col-12 pl-3 text-left">
        <h6 class="card-title" style="text-transform:uppercase;">{{$store.translate('team')}}: {{config.text}}</h6>
      </div>
    </div>
       </div>

    <div class="card-body p-0 m-0">
      <div class="row p-0 m-0">
        <div class="col p-0 m-0" style="min-height:170px;">
          <simple-doughnut-chart v-if="hasData == true" ref="chart" height="170px" width="170px">
            {{text}}
          </simple-doughnut-chart>
          <img v-if="hasData == false" src="/Images/pie-diagram.png" width="100" height="100" style="margin-top:10px;" />
          <div v-if="hasData == false">No data</div>
        </div>
      </div>
    </div>

  </div>



</template>

<script>

  import DoughnutDiagram from '../../charts/simple-doughnut-chart.vue'
  var hasData = false;

  var config =
  {
    customstyle: "background-color:#92D050",
    customclass: "",
    abbreviation: "T1",
    data: 8,
    text: "Team 1",
    icon: null

  }




  var teamMembers = [];
  var teamId = 0;
  export default {
    name: "display-team-time",
    components: {
      DoughnutDiagram
    },
    props: {
      enableedit: {
        required: false,
        type: String,
        default: "false"
      },
      type: {
        required: false,
        type: String,
        default: ""
      },
    },
    data() {
      return {
        teamMembers,
        teamId,
        config,
        text: '',
        hasData
      };
    },

    methods: {
      getId() {
        return "child_" + this._uid;
      },
      toggleActivation() {

      },
      handleRefresh(val) {
        this.$forceUpdate();
      },
      removeMe() {
        this.$emit('remove', this.getId());
      },
    
      setConfig(config) {      
        this.config = config;
        this.teamId = config.data.toString();
      },
      recalculate(data) {
        this.hasData = false;
        var teamHours = data.TeamHours;
        var total = teamHours[this.config.data + "-estimatedtime"];
        var done = teamHours[this.config.data + "-hoursspent"];
        this.text = done + "h";
        var left = total - done;
        if (left < 0)
          left = 0;

        if (total > 0) {
          this.hasData = true;
        }

        this.$refs.chart.setData(["left", "done"], [left, done]);
      }
    },
    computed: {

    },
    mounted() {
      this.$refs.chart.setData(["done", "started", "created"], [0, 0, 0]);
      vm.$root.$on('statistics', this.recalculate);
      vm.$emit('doSearch');
    },

    created: function () {

    },

    watch: {     
    },
    created() {
      //this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>

  .card-header.bg-dark {
    background-color: #f6f7f7 !important;
    color: black !important;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .table td {
    padding: 3px !important;
    padding-top:5px;
    border-bottom: 1px solid #ddd;
    border-top: 0px solid #ddd;
  }

  @media screen and (max-width:768px) {
    .card {
      margin-left: 5px !important;
      width: 185px !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/filter/displayers/display-team-time.vue